module.exports = __webpack_public_path__ + "img/RX-Arcos-3-zoom.75c58d7c.png";